import axios from 'axios';
import requestInterceptors from '../../../util/Common/API/requestInterceptors';
import responseInterceptors from '../../../util/Common/API/responseInterceptors';

const SAFETY_IT_TABLET_BASE_URL = `${process.env.REACT_APP_BASE_URL}/safety/it-tablet`;

/**
 * @description
 * Function that configure axios property
 * @param {string | any} withCredentials
 * Parameter to include credentials in the request
 * @param {string | any} xsrfHeaderName
 * Parameter to include xsrf header name
 * @param {string | any} xsrfCookieName
 * Parameter to include xsrf cookie name
 * @param {object} headers
 * Parameter to include headers
 * @returns {object}
 * Axios property
 */
const configureAxiosProperty = ({
  withCredentials,
  xsrfHeaderName,
  xsrfCookieName,
  headers,
}) => {
  return {
    withCredentials: withCredentials || true,
    xsrfHeaderName: xsrfHeaderName || 'X-CSRFTOKEN',
    xsrfCookieName: xsrfCookieName || 'XCSRF-TOKEN',
    headers: {
      ...headers,
    },
  };
};

/**
 * Axios object with base url
 */
const createSafetyITTabletDefaultAPI = (props = {}) => {
  const { withCredentials, xsrfHeaderName, xsrfCookieName, headers } = props;

  const axiosInstance = axios.create({
    baseURL: SAFETY_IT_TABLET_BASE_URL,
    ...configureAxiosProperty({
      withCredentials,
      xsrfHeaderName,
      xsrfCookieName,
      headers,
    }),
  });

  requestInterceptors({ axiosInstance });
  responseInterceptors({ axiosInstance });

  return axiosInstance;
};

const safetyITTabletDefaultAPI = createSafetyITTabletDefaultAPI();

export default safetyITTabletDefaultAPI;
